<script setup>
defineProps({
    path: {
        type: String,
        default: '',
    },
    viewBox: {
        type: String,
        default: '0 0 24 24',
    },
    content: {
        type: String,
        default: '',
    },
})
</script>

<template>
    <svg
        style="fill: currentColor"
        class="v-icon__svg"
        xmlns="http://www.w3.org/2000/svg"
        :viewBox="viewBox"
    >
        <template v-if="content"><g v-html="content" /></template>
        <path
            v-else
            :d="path"
        />
    </svg>
</template>
